/**
 * Builds a full merchant callback URL by appending the relative path
 * and query arguments with the correct separator.
 */
export const buildMerchantCallbackUrl = (baseUrl: string, relativeCallbackUrl: string, queryArgs: string): string => {
  const url = baseUrl + relativeCallbackUrl
  if (!queryArgs) return url
  const separator = url.includes('?') ? '&' : '?'
  const normalizedArgs = queryArgs.replace(/^[?&]/, '')
  return `${url}${separator}${normalizedArgs}`
}
